import { createFileRoute } from '@tanstack/react-router'
import { OrganizerProfileEditor } from '~/features/organizer/components/organizer-profile-editor'

export const Route = createFileRoute('/dashboard/organizer')({
  validateSearch: (search: Record<string, unknown>): { new?: boolean } =>
    search.new === true || search.new === '1' || search.new === 1 ? { new: true } : {},
  component: OrganizerRoute,
})

function OrganizerRoute() {
  const search = Route.useSearch()
  return <OrganizerProfileEditor key={search.new ? 'new' : 'edit'} creating={!!search.new} />
}
